import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from "ag-grid-community";
import { ShoppingCartListComponent } from '../../components/shopping-cart-list/shopping-cart-list.component';

@Component({
  selector: 'cv-subtotal-rendered',
  template: `
    <span [hidden]="data == null">
        <span class="my-value">{{+cellValue === 1 ? getFormatedValue(cellValue , "Coin", "Coin") : getFormatedValue(cellValue , "Coins", "Coins")}}</span>
    </span>
    `,
})
export class SubtotalRenderedComponent implements ICellRendererAngularComp {
  public cellValue!: string;
  public data!: any;

  constructor(public shoppingCartListComponent: ShoppingCartListComponent) { }

  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getFormatedValue(value, key, defaultValue) {
    return this.shoppingCartListComponent.cvNumberLocalize.transform(value) + ' ' + this.shoppingCartListComponent.getLocalizationString(key, defaultValue);
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
